import React from 'react';

export function formatHTML(text){
  //se reemplazan los enlaces
  while (text.indexOf(' /a')!==-1) {
    let init = text.indexOf(' /a')+3;
    let fin = text.indexOf(' ', init);
    if(fin===-1) fin = text.length;

    let subtext = text.substring(init, fin);
    let enlace = subtext.split(';');
    text = text.replace("/a"+subtext, "<a href='"+enlace[0]+"'>"+enlace[1]+"</a>");
  }
  //se reemplazan los enter
  text = text.split('\n').map((item, key) => {
    if (item.trim().charAt(0)==="?" || item.trim().charAt(0)==="-") {
      return "<li>"+item.substring(1)+"</li>";
    }
    return "<span>"+item+"<br/></span>";
  })

  return <span dangerouslySetInnerHTML={{__html: text.join("")}}/>;
}



// WEBPACK FOOTER //
// ./src/utils/index.js